<template>
  <div class="container-fluid">
    <nav-header :navItems="[
      {
        name: 'Job Templates',
        link: {
          name: 'Cid Specific Job Templates',
        },
      },
      {
        name: `${jobTemplate ? jobTemplate.name : 'Job Template'}`,
        link: {
          name: 'Cid Specific Job Template',
          params: {
            id: ` `,
          },
        },
        closeTab: true,
        disable: true,
      },
    ]" pretitle="Template" :breadcrumbTitle="true" :editMode="editMode" @nav-close-clicked="closeClick"
      @prevent-navigation="showPopup">
      <template v-slot:breadcrumb-title>
        <nav aria-label="breadcrumb" class="header-title">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a @click="closeClick" href="#" class="h1">Cid Specific Job Templates</a>
            </li>
            <li class="breadcrumb-item active h1" aria-current="page">
              {{ currentPage }}
            </li>
          </ol>
        </nav>
      </template>
      <template v-slot:header-button-content>
        <div class="custom-btn-group">
          <span v-if="editMode">
            <button @click.prevent="onSaveClick()" class="btn btn-success">Save</button>
            <button @click.prevent="onDeleteClick()" class="btn btn-danger">
              Delete
            </button>
            <button @click.prevent="onCancelClick()" class="btn btn-secondary">
              Cancel
            </button>
          </span>
          <span v-else-if="!editMode && !hideEditBtn">
            <button type="button" @click.prevent="onEditClick()" class="btn btn-primary">
              Edit
            </button>
          </span>
          <span v-else-if="hideEditBtn">
            <button type="button" @click.prevent="showModal({ component: 'AddJobTemplate', data: 'cid specific'})" class="btn btn-primary">
              Create Template
            </button>
          </span>
        </div>

      </template>
    </nav-header>
    <div v-if="error" class="alert alert-danger" role="alert">
      {{ error }}
    </div>
    <div>
      <router-view :editMode="editMode" :saveJobTrigger="saveJobTrigger" :cancelClick="cancelClick"
        v-on:setSaveConfigBtn="setSaveConfigBtn" v-on:hideEdit="setHideEdit" v-on:triggerEditMode="setEditMode"
        v-on:setJobTemplate="setJobTemplate">
      </router-view>
    </div>
  </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from "vuex";
export default {
  components: { NavHeader },
  data() {
    return {
      error: null,
      jobTemplate: null,
      snapshot: null,
      saveJobTrigger: false,
      cancelClick: false,
      editMode: false,
      hideEditBtn: true,
      showSaveConfigBtn: false,
      currentPage: "Job Templates",
    };
  },
  watch: {
    "$route.params.id": {
      handler: function (to, from) {
        if (to) {
          this.setHideEdit(true);
        } else {
          this.setEditMode(false);
          this.setHideEdit(true);
        }
      },
    },
  },
  methods: {
    ...mapActions({
      showModal: "showModal",
      deleteJobTemplate: "admin/deleteJobTemplate",
    }),
    setJobTemplate(job) {
      this.jobTemplate = job;
    },
    closeClick() {
      this.jobTemplate = null;
      this.$router.push({
        name: "Cid Specific Job Templates",
      });
    },
    showPopup() {
      var self = this;
      this.showModal({
        component: "confirm",
        data: {
          title: "Save Changes",
          message: `Do you want to save changes ?`,
          async confirm() {
            self.onSaveClick();
          },
          async cancel() {
            self.onCancelClick();
          },
        },
      });
    },
    setHideEdit(hideEdit) {
      this.hideEditBtn = hideEdit;
    },
    setEditMode(mode) {
      this.editMode = mode;
      this.successMessage = null;
      this.error = null;
    },
    setSaveConfigBtn(val) {
      this.showSaveConfigBtn = val;
    },
    onEditClick() {
      this.setEditMode(true);
    },
    onSaveClick() {
      this.successMessage = null;
      this.error = null;
      this.saveJobTrigger = !this.saveJobTrigger;
      this.setEditMode(false);
    },
    onDeleteClick() {
      const self = this;
      this.showModal({
        component: "confirm",
        data: {
          title: "Delete Job Template",
          message: `Are you sure you want to delete ${this.jobTemplate.name}?`,
          async confirm() {
            try {
              await self.deleteJobTemplate(self.jobTemplate.id);
              let toastoptions = {
                message:
                  "Job template '" + self.jobTemplate.name + "' deleted successfully.",
                type: "success",
              };
              self.$store.dispatch("addToast", toastoptions);
              self.$store.dispatch("hideModal");
              self.$router.push({
                name: "Cid Specific Job Templates",
              });
            } catch (error) {
              if (error.response && error.response.data.error)
                self.error = error.response.data.error;
              else self.error = error.message;
              return;
            }
          },
        },
      });
    },
    onCancelClick() {
      this.cancelClick = !this.cancelClick;
      this.setEditMode(false);
    },
  },
};
</script>

<style scoped>
.custom-btn-group {
  display: flex;
  align-items: center;
}

.btn {
  margin-right: 12px;
}
</style>
